import { computed } from 'vue';
import { defineStore } from 'pinia';
import { captureException } from '@sentry/vue';

import { getDomain, redirect, getCurrentOrigin } from '@libs/utils';

export const useCoreStore = defineStore('CoreStore', () => {
  function redirectToMainPage(): void {
    redirect(getCurrentOrigin());
  }

  function openSupportPage(): void {
    const supportPageUrl = getDomain.getCurrentDomainSpec().SupportPage;
    openInNewTab(supportPageUrl);
  }

  function getTravelGuaranteePage(): string {
    const swedishGuaranteeUrl =
      'https://www.kammarkollegiet.se/vara-tjanster/resegaranti';
    const internationalGuaranteeUrl =
      'https://www.kammarkollegiet.se/engelska/start/all-services/travel-guarantees/sdg/information-about-travel-guarantees';
    const url =
      getDomain.getCurrentDomainSpec().Locale === 'sv'
        ? swedishGuaranteeUrl
        : internationalGuaranteeUrl;
    return url;
  }

  function openInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  function handleImageLoadError(src: string): void {
    captureException(
      new Error(`Product card image failed loading from ${src}`)
    );
  }

  // Getters
  const currentDomain = computed(() => getDomain.getCurrentDomainSpec().Domain);

  return {
    // Actions
    handleImageLoadError,
    openSupportPage,
    openInNewTab,
    redirectToMainPage,
    getTravelGuaranteePage,

    // Getters
    currentDomain,
  };
});
